import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'
import { computed } from 'vue'

export function useDisplay() {
  const breakpoints = useBreakpoints(breakpointsTailwind)

  const isMobile = computed(() => {
    return breakpoints.isSmaller('md')
  })

  return { ...breakpoints, isMobile }
}
